import triggerEcommerceTracking from "../common/functions/triggerEcommerceTracking";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.home.pc").length) return;
  $(".jsCarousel").slick({
    dots: true,
    centerMode: true,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 3000,
    prevArrow: $(".jsSlickPrev"),
    nextArrow: $(".jsSlickNext"),
    lazyLoad: "progressive",
  });

  const trackingListNames = [
    "gtmFeaturedVolunteer",
    "gtmFeaturedJob",
    "gtmNewVolunteer",
    "gtmNewJob",
  ];
  trackingListNames.forEach((listName) => {
    triggerEcommerceTracking(listName);
  });
});
